<template>
    <b-container>
        <b-form>
            <div v-for="(question, index) in questionaire" :key="index">
                <template v-if="question.type === 'short_answer'">
                    <b-form-group
                        :label-for="`question-${index}-shortanswer`"
                        :description="question.description"
                    >
                        <p>{{question.question}}:</p>
                        <b-form-input
                            :id="`question-${index}-shortanswer`"
                            :label="question.question"
                            v-model="question.value"
                            :required="question.required"
                            :placeholder="question.placeholder"
                            :disabled="screening.status.submitted"
                        ></b-form-input>
                    </b-form-group>
                </template>
                <template v-else-if="question.type === 'essay'">
                    <b-form-group
                        :label="question.label"
                        :label-for="`question-${index}-essay`"
                        :description="question.description"
                    >
                        <b-form-textarea
                            :id="`question-${index}-essay`"
                            :placeholder="question.placeholder"
                            class="mb-4"
                            rows="3"
                            max-rows="6"
                            :disabled="screening.status.submitted"
                        ></b-form-textarea>
                    </b-form-group>
                </template>
                <template v-else-if="question.type === 'checkbox'">
                    <b-form-group
                        :label="question.label"
                        :label-for="`question-${index}-checkbox`"
                        :description="question.description"
                        v-model="question.value"
                    >
                        <b-form-checkbox-group>
                            <b-form-checkbox 
                                v-for="(answer, cbidx) in question.answers" 
                                :key="cbidx"
                                :id="`question-${index}-checkbox`"
                                :value="answer.value" 
                            >{{ answer.label }}</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>
                </template>
                <template v-else-if="question.type === 'multiple_choice'">
                    <b-form-group
                        :label="question.question"
                        :description="question.description || ''"
                    >
                        <b-form-radio-group v-model="question.user_answer">
                            <b-form-radio 
                                v-for="(answer, idx) in question.options"
                                :id="`question-${index}-multiplechoice-${idx}`"
                                :key="idx"
                                :value="answer"
                                :selected="answer === question.user_answer"
                                :disabled="screening.status.submitted"
                            >{{ answer }}</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </template>
            </div>
        </b-form>
    </b-container>
</template>

<script>
export default {
    props: ['screening'],
    computed: {
        questionaire () {
            return this.screening.questionnaire;
        }
    }
}
</script>